import React from "react";

import { PageLayoutRoot } from "./PageLayout.styles";

interface PageLayoutProps {
  testId?: string;
  children: React.ReactNode;
}

/**
 * Root page layout component that provides the container for all page layout slots.
 * This component should wrap all other layout components (Banner, TopNavigation, LeftPanel, Content, etc.).
 */
const PageLayout: React.FC<PageLayoutProps> = ({ testId, children }) => {
  return <PageLayoutRoot data-testid={testId}>{children}</PageLayoutRoot>;
};

export default PageLayout;
